module.exports = __webpack_public_path__ + "img/avito.228f1aa5.svg";